import { render, staticRenderFns } from "./AppIconBtn.vue?vue&type=template&id=fe25174c&scoped=true&"
import script from "./AppIconBtn.vue?vue&type=script&lang=js&"
export * from "./AppIconBtn.vue?vue&type=script&lang=js&"
import style0 from "./AppIconBtn.vue?vue&type=style&index=0&id=fe25174c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe25174c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
